<template>
    <q-page class="q-pa-md">
        <q-dialog v-model="dialogRegiones">
            <q-card style="min-width: 850px;">
                <q-card-section class="row items-center no-wrap">
                    <div class="row q-col-gutter-md">
                        <div class="col-6">
                            <q-list bordered separator style="width: 400px;">
                                <q-item-label header>Regiones Asignadas</q-item-label>
                                <q-item active v-ripple v-for="a in itemsEstados" :key="a.estado" tabindex="0">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-hospital-box" />
                                    </q-item-section>
                                    <q-item-section>{{ a.estado }}</q-item-section>
                                    <q-item-section side>Región</q-item-section>
                                    <q-item-section top side>
                                        <div class="text-grey-8 q-gutter-xs">
                                            <q-btn color="red" flat round icon="delete"
                                                @click="DeleteUsuarioBaseDatos(a)" />
                                        </div>
                                    </q-item-section>
                                </q-item>
                            </q-list>
                        </div>
                        <div class="col-6">
                            <q-list bordered separator style="width: 400px;">
                                <q-item-label header>Regiones No Asignadas</q-item-label>
                                <q-item active v-ripple v-for="a in itemsEstadosFaltantes" :key="a.estado" tabindex="0">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-hospital-box" />
                                    </q-item-section>
                                    <q-item-section>{{ a.estado }}</q-item-section>
                                    <q-item-section side>Región</q-item-section>
                                    <q-item-section top side>
                                        <div class="text-grey-8 q-gutter-xs">
                                            <q-btn color="blue" flat round icon="mdi-plus"
                                                @click="PostUsuarioBaseDatos(a)" />
                                        </div>
                                    </q-item-section>
                                </q-item>
                            </q-list>
                        </div>
                    </div>
                    <!-- <q-list bordered separator style="width: 400px;">
                        <q-item-label header>Regiones</q-item-label>
                        <q-item active v-ripple v-for="a in itemsEstados" :key="a.estado" tabindex="0">
                            <q-item-section avatar>
                                <q-icon name="mdi-hospital-box" />
                            </q-item-section>
                            <q-item-section>{{ a.estado }}</q-item-section>
                            <q-item-section side>Región</q-item-section>
                            <q-item-section top side>
                                <div class="text-grey-8 q-gutter-xs">
                                    <q-btn color="red" flat round icon="delete" />
                                </div>
                            </q-item-section>
                        </q-item>

                    </q-list> -->
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogSedes">
            <q-card style="min-width: 850px;">
                <q-card-section class="row items-center no-wrap">
                    <div class="row q-col-gutter-md">
                        <div class="col-6">
                            <q-list bordered separator style="width: 400px;">
                                <q-item-label header>Sedes Asignadas</q-item-label>
                                <q-item active v-ripple v-for="a in itemsSedesUsuario" :key="a.sede" tabindex="0">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-hospital-box" />
                                    </q-item-section>
                                    <q-item-section>{{ a.sede }}</q-item-section>
                                    <q-item-section side>Sede</q-item-section>
                                    <q-item-section top side>
                                        <div class="text-grey-8 q-gutter-xs">
                                            <q-btn color="red" flat round icon="delete" @click="DeleteUsuarioSede(a)" />
                                        </div>
                                    </q-item-section>
                                </q-item>
                            </q-list>
                        </div>
                        <div class="col-6">
                            <q-list bordered separator style="width: 400px;">
                                <q-item-label header>Sedes No Asignadas</q-item-label>
                                <q-item active v-ripple v-for="a in itemesTodosSedes" :key="a.sede" tabindex="0">
                                    <q-item-section avatar>
                                        <q-icon name="mdi-hospital-box" />
                                    </q-item-section>
                                    <q-item-section>{{ a.sede }}</q-item-section>
                                    <q-item-section side>Sede</q-item-section>
                                    <q-item-section top side>
                                        <div class="text-grey-8 q-gutter-xs">
                                            <q-btn color="blue" flat round icon="mdi-plus"
                                                @click="PostUsuarioSede(a)" />
                                        </div>
                                    </q-item-section>
                                </q-item>
                            </q-list>
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-dialog>

        <q-dialog v-model="confirm" persistent>
            <q-card>
                <q-card-section class="row items-center">
                    <div class="row no-wrap q-pa-md ">
                        <div class="column text-center">
                            <q-avatar size="80px" icon="mdi-delete-alert" color="warning" text-color="white" />
                        </div>
                        <q-separator vertical inset class="q-mx-lg" />
                        <div class="column text-center">
                            <span class="text-h5 q-ml-lg">¿Estas seguro de eliminar el usuario <strong>{{ item.nombre
                                + ' ' + item.apellidos }}</strong> .?</span>
                        </div>
                    </div>
                </q-card-section>

                <q-card-actions align="right">
                    <q-btn flat label="Cerrar" color="primary" v-close-popup />
                    <q-btn flat label="Eliminar" color="primary" @click="DeleteItem()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <q-dialog v-model="dialogNuevoUsuario" persistent>
            <q-card style="width: 500px; max-width: 80vw;">
                <q-bar class="bg-primary text-white">
                    <q-icon color="white" name="mdi-account" />
                    <div>Nuevo usuario</div>
                    <q-space />

                    <q-btn dense flat icon="close" v-close-popup>
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </q-bar>

                <q-card-section class="q-col-gutter-sm">
                    <q-input filled dense v-model="item.email" type="email" placeholder="Email" label="Email"></q-input>
                    <q-input filled dense v-model="item.nombre" placeholder="Nombre" label="Nombre"></q-input>
                    <q-input filled dense v-model="item.apellidos" placeholder="Apellidos" label="Apellidos"></q-input>
                    <q-input filled dense v-model="item.telefono" mask="(###) ### - ####" placeholder="Teléfono"
                        label="Teléfono"></q-input>
                    <q-select filled dense v-model="item.rol" label="Rol"
                        :options="['Administrador', 'Controller', 'Coordinador']"></q-select>
                    <q-input filled dense v-model="item.password" placeholder="Contraseña" label="Contraseña"
                        :type="isPwd ? 'password' : 'text'">
                        <template v-slot:append>
                            <q-icon :name="isPwd ? 'visibility_off' : 'visibility'" class="cursor-pointer"
                                @click="isPwd = !isPwd" />
                        </template>
                    </q-input>
                </q-card-section>
                <q-card-actions align="right" class="text-right">
                    <q-btn flat color="primary" label="CERRAR" v-close-popup />
                    <q-btn flat color="primary" label="CREAR USUARIO" @click="postUsuario()" />
                </q-card-actions>
            </q-card>
        </q-dialog>

        <div class="row q-col-gutter-md q-mt-sm">
            <div class="col-12 col-md-12 ">
                <q-table dense :data="data" :columns="columns" row-key="_id" title="Lista de Usuarios" :filter="filter"
                    :loading="loading" :pagination="{ rowsPerPage: 10 }">
                    <template v-slot:top>
                        <div class="text-h5">Lista de Usuarios</div>
                        <q-space />
                        <q-btn class="q-mt-md" color="primary" icon="mdi-plus" label="NUEVA USUARIO"
                            @click="nuevoUsuario()" />
                        <q-btn round color="primary" icon="mdi-refresh" class="q-ml-md q-mt-md"
                            @click="getListaUsuarios()" />
                    </template>
                    <template v-slot:body="props">
                        <q-tr :props="props">
                            <q-td auto-width key="acciones">
                                <q-btn size="md" color="red" rounded flat dense @click="eliminarUsuario(props.row)"
                                    icon="mdi-delete">
                                    <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                        content-style="font-size: 14px">Eliminar</q-tooltip>
                                </q-btn>
                                <q-btn size="md" color="primary" rounded flat dense @click="GetEstados(props.row)"
                                    icon="mdi-view-list">
                                    <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                        content-style="font-size: 14px">Ver Regiones</q-tooltip>
                                </q-btn>
                                <q-btn v-if="props.row.rol == 'Coordinador'" size="md" color="blue-9" rounded flat dense
                                    @click="GetSedesUsuario(props.row)" icon="mdi-map-marker-radius">
                                    <q-tooltip transition-show="flip-right" transition-hide="flip-left"
                                        content-style="font-size: 14px">Ver Sedes
                                    </q-tooltip>
                                </q-btn>
                            </q-td>
                            <q-td key="email" :props="props">
                                {{ props.row.email }}
                            </q-td>
                            <q-td key="nombre" :props="props">
                                {{ props.row.nombre }}
                            </q-td>
                            <q-td key="apellidos" :props="props">
                                {{ props.row.apellidos }}
                            </q-td>
                            <q-td key="telefono" :props="props">
                                {{ props.row.telefono }}
                            </q-td>
                            <q-td key="rol" :props="props">
                                {{ props.row.rol }}
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
        </div>
    </q-page>
</template>
<script>
import axios from 'axios'
import { date, QSpinnerFacebook } from 'quasar'
import { format } from 'date-fns';

export default {
    components: {
    },
    data() {
        return {
            columns: [
                { name: 'actions', align: 'center', label: 'Acciones', field: 'actions', sortable: true },
                {
                    name: 'email', align: 'center', label: 'Email', field: 'email', sortable: true, classes: 'bg-grey-2 ellipsis',
                    style: 'max-width: 100px',
                    headerClasses: 'bg-primary text-white'
                },
                {
                    name: 'nombre',
                    field: 'nombre',
                    required: true,
                    label: 'Nombre',
                    align: 'center',
                    sortable: true,

                },
                { name: 'apellidos', align: 'center', label: 'Apellidos', field: 'apellidos', sortable: true },
                { name: 'telefono', align: 'center', label: 'Teléfono', field: 'telefono', sortable: true },
                { name: 'rol', align: 'center', label: 'Rol', field: 'rol', sortable: true },
            ],
            data: [],
            filter: '',
            loading: false,
            dialogNuevoUsuario: false,

            isPwd: true,
            confirm: false,
            item: { _id: '', email: '', nombre: '', apellidos: '', telefono: '', password: '', estatus: 'Vigente', rol: '', fechaCreacion: '' },
            itemsEstados: [],
            dialogRegiones: false,
            itemsEstadosFaltantes: [],
            id_usuario: null,
            itemsSedesUsuario: [],
            itemesTodosSedes: [],
            dialogSedes: false
        }
    },
    created() {
        this.getListaUsuarios();
    },
    computed: {
        usuarioStore() {
            return this.$store.state.usuario;
        },
    },
    methods: {
        async getListaUsuarios() {
            this.loading = true
            try {
                let response = await axios.get("Login/GetUsuarios");
                this.data = response.data;
                this.loading = false
            } catch (error) {
                console.log(error);
                this.loading = false
            }
        },

        async postUsuario() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            if (this.item.email == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el email.' })
                return;
            }

            if (this.item.nombre == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique el nombre del usuario.' })
                return;
            }

            if (this.item.apellidos == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Indique sus apellidos' })
                return;
            }

            if (this.item.password == '') {
                this.$q.notify({ type: 'warning', position: 'top-right', message: 'Asigne una contraseña' })
                return;
            }

            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'primary', spinnerSize: 120, message: 'Guardando usuario. Espere...', messageColor: 'white' })

            let fecha = new Date()
            let fechaC = format(fecha, "yyyy-MM-dd HH:mm:ss");
            this.item.fechaCreacion = fechaC
            console.log(this.item)

            try {
                let response = await axios.post("Login/PostRegistroNuevo", this.item);
                console.log(response)
                this.$q.loading.hide()
                this.getListaUsuarios()

                this.$q.notify({ position: 'top-right', type: 'positive', message: `Usuario registrado correctamente.` })

            } catch (error) {
                console.log(error);
                this.$q.loading.hide()
            }
        },
        eliminarUsuario(item) {
            this.item = { ...item }
            this.confirm = true
        },
        async putUsuario() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            var estatus = 'activo'

            if (this.usuairoItem.estatus == 'activo') {
                estatus = 'inactivo'
            }

            let objeto = {
                id_usuario: this.usuairoItem.id_usuario,
                estado: estatus
            }

            this.$q.loading.show({ spinner: QSpinnerGrid, spinnerColor: 'primary', spinnerSize: 120, message: 'Actualizando usuario. Espere...', messageColor: 'white' })

            try {
                let response = await axios.put("Usuarios/ActualizaEstado", objeto);
                console.log(response)
                this.$q.loading.hide()
                this.getListaUsuarios()
                this.confirm = false
            } catch (error) {
                console.log(error);
                this.$q.loading.hide()

            }
        },
        nuevoUsuario() {
            this.dialogNuevoUsuario = true
            this.item = { _id: '', email: '', nombre: '', apellidos: '', telefono: '', password: '', estatus: 'Vigente', rol: 'Administrador', fechaCreacion: '' }
        },
        async DeleteItem() {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            this.$q.loading.show({ spinner: QSpinnerFacebook, spinnerColor: 'white', spinnerSize: 140, message: 'Eliminando Usuario. Espere...', messageColor: 'white' })
            try {
                let respuesa = await axios.post('Login/DeleteUsuarios/' + this.item._id,)
                this.$q.notify({ position: 'top-right', type: 'positive', message: `El usuario se ha eliminado correctamente.` })
                console.log(respuesa)
                this.$q.loading.hide()
                await this.getListaUsuarios();
                this.confirm = false
            } catch (error) {
                this.$q.loading.hide()
                console.log(error)
            }
        },
        async GetEstados(item) {
            this.id_usuario = item
            try {
                let response = await axios.get('Login/GetEstados/' + item._id)
                console.log(response)
                this.itemsEstados = response.data
                await this.GetTodosEstados()
                this.dialogRegiones = true
            } catch (error) {
                console.log(error)
            }
        },
        async GetTodosEstados() {
            try {
                let response = await axios.get('Login/GetTodosEstados/')
                console.log(response)
                let todas = response.data
                const idsAsignadas = this.itemsEstados.map(b => b._id);
                this.itemsEstadosFaltantes = todas.filter(b => !idsAsignadas.includes(b._id));
            } catch (error) {
                console.log(error)
            }
        },

        async PostUsuarioBaseDatos(item) {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            let objeto = {
                _id: '',
                _id_usuario: this.id_usuario._id,
                _id_basedatos: item._id
            }
            try {
                let response = await axios.post("Login/PostUsuarioBaseDatos/" + this.id_usuario.rol, objeto);
                console.log(response)
                await this.GetEstados(this.id_usuario);
                await this.GetTodosEstados();

            } catch (error) {
                console.log(error);
                this.$q.loading.hide()
            }
        },

        async DeleteUsuarioBaseDatos(item) {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            try {
                let response = await axios.put("Login/DeleteUsuarioBaseDatos/" + this.id_usuario._id + '/' + item._id);
                console.log(response)
                await this.GetEstados(this.id_usuario);
                await this.GetTodosEstados();

            } catch (error) {
                console.log(error);
                this.$q.loading.hide()
            }
        },

        async GetSedesUsuario(item) {
            this.id_usuario = item
            try {
                let response = await axios.get('Login/GetSedesUsuario/' + item._id)
                console.log(response)
                this.itemesTodosSedes = response.data.listaSedesNoAsignadas
                this.itemsSedesUsuario = response.data.listaSedesAsignadas
                this.dialogSedes = true
            } catch (error) {
                console.log(error)
            }
        },

        async PostUsuarioSede(item) {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }

            let objeto = {
                _id: '',
                _id_usuario: this.id_usuario._id,
                _id_sede: item._id
            }
            try {
                let response = await axios.post("Login/PostUsuarioSede", objeto);
                console.log(response)
                await this.GetSedesUsuario(this.id_usuario);

            } catch (error) {
                console.log(error);
                this.$q.loading.hide()
            }
        },

        async DeleteUsuarioSede(item) {
            if (this.$store.state.usuario.rol != 'Administrador') {
                this.$q.notify({
                    position: 'top-right',
                    message: 'El usuario no cuenta con los permisos necesarios para realizar esta acción.',
                    color: 'info',
                    icon: 'warning'
                })
                return
            }
            try {
                let response = await axios.put("Login/DeleteUsuarioSede/" + this.id_usuario._id + '/' + item._id);
                console.log(response)
                await this.GetSedesUsuario(this.id_usuario);


            } catch (error) {
                console.log(error);
                this.$q.loading.hide()
            }
        },

    }
}
</script>